import { useLoaderData, useNavigate } from '@tanstack/react-router'
import { COMPANIES_PATH } from 'commons/constants/routes'
import { Page, PageFace } from 'ui/components/Page'

import { useCompanyDelete } from '../../../../hooks'
import { CompanyManage } from '../../../../typings'
import { ManageCompanyForm } from './components/ManageCompanyForm'
import { Footer } from './components/ManageCompanyForm/components'
import { useManageCompanyForm } from './components/ManageCompanyForm/hooks/useManageCompanyForm'

export const ManageCompanyPage = () => {
  const navigate = useNavigate()
  const companyData = useLoaderData({ strict: false }) as CompanyManage

  const { DeleteConfirmation, onDeleteCompany, companyForDelete } = useCompanyDelete(() => {
    navigate({ to: COMPANIES_PATH })
  })

  const { form } = companyData
  const { name, id } = form

  const { config, Field, submitHandler, deleteHandler, isSubmitting, isDirty } = useManageCompanyForm(
    form,
    onDeleteCompany
  )

  return (
    <Page
      title="Company Profile"
      face={PageFace.SECONDARY}
      isPending={!companyData}
      subTitle={name || (!!companyData && id && 'New Company') || '...'}
      footer={
        <Footer
          returnUrl={id ? `${COMPANIES_PATH}/${config?.value.id}` : COMPANIES_PATH}
          onSubmit={submitHandler}
          onDelete={id ? deleteHandler : undefined}
          isSubmitting={isSubmitting ?? false}
        />
      }
    >
      <DeleteConfirmation />
      {!!companyData && (
        <ManageCompanyForm
          companyData={companyData}
          companyForDelete={companyForDelete}
          Field={Field}
          config={config}
          isSubmitting={isSubmitting}
          isDirty={isDirty}
        />
      )}
    </Page>
  )
}
